// Shorten wallet address with ellipsis in middle
export const shortenAddress = (address: string): string => {
  return `${address.slice(0, 6)}...${address.slice(-6)}`;
};

// Format number with comma for thousand onwards
export const formatNumber = (
  value: number,
  maximumFractionDigits?: number,
  minimumFractionDigits?: number
): string => {
  return Number(value).toLocaleString('en-US', {
    maximumFractionDigits: maximumFractionDigits ?? 2,
    minimumFractionDigits: minimumFractionDigits ?? 0,
  });
};

export const truncateMiddle = (
  fullStr: string,
  strLen: number,
  separator?: string
) => {
  if (fullStr.length <= strLen) return fullStr;

  separator = separator || '...';

  var sepLen = separator.length,
    charsToShow = strLen - sepLen,
    frontChars = Math.ceil(charsToShow / 2),
    backChars = Math.floor(charsToShow / 2);

  return (
    fullStr.substring(0, frontChars) +
    separator +
    fullStr.substring(fullStr.length - backChars)
  );
};

export const roundDown = (value: number, decimals: number) => {
  const factor = Math.pow(10, decimals);

  return Math.floor(value * factor) / factor;
};

export const truncateString = (numString: string, decimals: number) => {
  const decimalIndex = numString.indexOf('.');
  if (decimalIndex !== -1) {
    return numString.substring(0, decimalIndex + 1 + decimals);
  } else {
    return numString;
  }
};
